module.exports = __webpack_public_path__ + "static/img/product-show.a2c7fece.png";